import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/pdf-export.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Add performance monitoring
const startTime = performance.now();

// Sanitize error logging to prevent sensitive data leaks in production
window.addEventListener('error', (event) => {
  if (process.env.NODE_ENV === 'development') {
    // In development, log full error details for debugging
    console.error('An error occurred:', {
      message: event.message,
      stack: event.error?.stack,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno
    });
  } else {
    // In production, log minimal information to avoid leaking sensitive data
    console.error('An error occurred. Please try again or contact support.', {
      errorId: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
      type: event.error?.name || 'UnknownError'
    });
  }
});

// Log environment information for debugging
console.log('React app starting...');
if (process.env.NODE_ENV === 'development') {
  console.log('window._env_ exists:', typeof window._env_ !== 'undefined');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Only use StrictMode in development
if (process.env.NODE_ENV === 'development') {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
} else {
  root.render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  );
}

// Log performance metrics
window.addEventListener('load', () => {
  const loadTime = performance.now() - startTime;
  console.log(`App loaded in ${Math.round(loadTime)}ms`);
}); 